/*
  Example:
    import { parseDate } from '@/utilities/Date/parse'

    const parsedDate = parseDate (date, 'LL');
*/
import moment from 'moment'

export const parseDate = (date, format = 'LL') => {
  if (typeof date !== 'string') {
    console.debug(`parseDate can only parse a date string. got:`, { date })
    return date
  }

  try {
    const parsed = moment(date)
    if (parsed.isValid()) {
      date = moment(date).format(format)
    }
  } catch (exception) {
    if (exception && exception.message) {
      console.error(exception.message)
    } else {
      console.error(exception)
    }
  }

  return date
}
